"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitToQuery = void 0;
const enums_1 = require("../enums");
const unitToQuery = (time, unit) => `${time} ${unit === enums_1.SlaTimeUnitEnum.Hours ? 'HOUR' : 'DAY'}`;
exports.unitToQuery = unitToQuery;
